import { AddOutlined, Delete, TaskAlt } from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import { Grid, IconButton, Radio, Tooltip } from "@mui/material";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";

import Box from "../Box";
import Modal from "../Modal";
import Button from "../Button";
import FormField from "../FormField";
import Typography from "../Typography";
import Autocomplete from "../Autocomplete";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import PhoneNumberInput from "../PhoneNumberInput";
import UserService, { IDataRequestCreateUpdateUser } from "../../services/identity/user.service";

import { RoleHelpers } from "../../commons/roleHelpers";
import { ICodename, ILableOrganization } from "../../commons/interfaces";
import { ActionRequest, GroupUserDefault, InvitationDetailType, IsTrue } from "../../constants/enums";



interface IPropsModalCreateUpdateStaff {
    newDomain?: string
    visibleModal: boolean
    setVisibleModal: React.Dispatch<React.SetStateAction<boolean>>

    organizationId: string;
    dataRoles: ICodename[];
    dataGroups: ICodename[];
    dataUserTitle: ICodename[];

    requiredRole?: boolean;
    idDetailStaff?: string;
    groupIdDefault?: string;

    onClose?: () => void;
    onCallBack?: () => void;
}

export interface IDataModalCreateUpdateStaff {
    id?: string;
    email?: string;
    lastName?: string;
    firstName?: string;
    phoneNumber?: string;
    roleCodes: string[];
    userGroups: IModelWorkingGroup[];
}

interface IModelWorkingGroup {
    id?: string;
    groupId: string;
    groupName?: any;
    default: number;
    manager?: number;
    userTitle: string;
    action?: number;
}

type IErrorModelWorkingGroup = { [key in keyof IModelWorkingGroup]?: string };

type IErrorModalCreateUpdateStaff = { [key in keyof IDataModalCreateUpdateStaff]?: string };

function ModalCreateUpdateMember(props: IPropsModalCreateUpdateStaff & ILableOrganization) {
    const strings = useStrings();

    const {
        language,
        clientId,
        userInfo,
        tenantCode,
        serviceCode,
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [dataRoleDisabled, setDataRoleDisabled] = useState<string[]>([]);
    const [modelError, setModelError] = useState<IErrorModalCreateUpdateStaff>({});
    const [model, setModel] = useState<IDataModalCreateUpdateStaff>({ roleCodes: [], userGroups: [] });
    const [dataDetailUserBackup, setDataDetailUserBackup] = useState<IDataRequestCreateUpdateUser | undefined>(undefined);

    const [errorWorkingGroups, setErrorWorkingGroups] = useState<IErrorModelWorkingGroup[]>([]);
    const [selectedGroups, setSelectedGroups] = useState<Partial<Record<string, ICodename>>>({});
    const [dataWorkingGroups, setDataWorkingGroups] = useState<IModelWorkingGroup[]>([{
        id: "0",
        groupId: "",
        userTitle: "",
        manager: IsTrue.False,
        action: ActionRequest.Create,
        default: GroupUserDefault.Default,
    }]);

    const newListWorkingGroups = useMemo(() => (
        dataWorkingGroups.filter(el => el.action !== ActionRequest.Delete) || []
    ), [dataWorkingGroups]);

    const newLableStaff = useMemo(() => (
        (props.lableStaff || strings.Common.STAFF).toLowerCase()
    ), [props.lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (props.lableGroup || strings.Common.GROUP).toLowerCase()
    ), [props.lableGroup, strings]);

    const parentGroupList = useMemo(() => (
        props.dataGroups.filter(el => el.code !== props.groupIdDefault) || []
    ), [props.dataGroups, props.groupIdDefault]);

    const availableGroups = useMemo(() => {
        return parentGroupList.filter((grp) => !selectedGroups[grp.code]) || [];
    }, [selectedGroups, parentGroupList]);

    useEffect(() => {
        if (props.visibleModal) {
            if (!Helpers.isNullOrEmpty(props.idDetailStaff)) {
                getDetailStaff(props.idDetailStaff);
            } else {

            }
        }
    }, [props.visibleModal, props.idDetailStaff]);

    const getDetailStaff = async (id: string) => {
        try {
            onShowLoading();

            const userResult = await UserService.getDetail({
                id: id,
                clientId: clientId,
                organizationId: props.organizationId,
            });

            let groupUserTemp: any[] = [];
            let roleCodesTemp: string[] = [];
            let newRoleDisabled: string[] = [];

            if (
                !Helpers.isNullOrEmpty(userResult?.invitation) &&
                [...userResult?.invitation?.invitationDetails || []].length > 0
            ) {
                [...userResult?.invitation?.invitationDetails || []].forEach((item: any) => {
                    if (item.type === InvitationDetailType.Role) {
                        if (!Helpers.isNullOrEmpty(item.roleCode)) {
                            roleCodesTemp.push(item.roleCode);
                            if (RoleHelpers.isOrganizationOwner(Number(item.roleType))) {
                                !newRoleDisabled.includes(item.roleCode) &&
                                    newRoleDisabled.push(item.roleCode);
                            }
                        }
                    }
                    if (item.type === InvitationDetailType.Group) {
                        groupUserTemp.push({
                            id: item.id,
                            groupId: item.groupId,
                            userTitle: item.title,
                            default: item.groupDefault,
                            action: ActionRequest.Update,
                        });
                    }
                });
            } else {
                if ([...userResult?.userRoles || []].length > 0) {
                    [...userResult?.userRoles || []].forEach((el: any) => {
                        if (!Helpers.isNullOrEmpty(el.roleCode)) {
                            roleCodesTemp.push(el.roleCode);

                            if (RoleHelpers.isOrganizationOwner(Number(el.roleType))) {
                                !newRoleDisabled.includes(el.roleCode) &&
                                    newRoleDisabled.push(el.roleCode);
                            }
                        }
                    });
                }

                [...userResult.groupUsers || []]?.forEach((e: any) => {
                    groupUserTemp.push({
                        id: e.id,
                        groupId: e.groupId,
                        manager: e.manager,
                        default: e.default,
                        userTitle: e.userTitle,
                        groupName: e.groupName,
                        action: ActionRequest.Update,
                    });
                });
            }

            const newDataDetail: IDataModalCreateUpdateStaff = {
                id: id,
                roleCodes: roleCodesTemp,
                userGroups: groupUserTemp,
                email: userResult.organizationUserProfile?.email || "",
                lastName: userResult.organizationUserProfile?.lastName || "",
                firstName: userResult.organizationUserProfile?.firstName || "",
                phoneNumber: userResult?.organizationUserProfile?.phoneNumber || "",
            };

            setModelError({});
            setModel(newDataDetail);

            setDataDetailUserBackup({
                // clientId: userResult?.clientId,
                // tenantCode: userResult?.tenantCode,
                // serviceCode: userResult?.serviceCode,
                organizationId: userResult?.organizationUserProfile?.organizationId,

                id: userResult?.id,
                email: userResult?.email,
                // gender: userResult?.gender,
                userName: userResult?.userName,
                // password: userResult?.password,
                fullName: userResult?.fullName,
                avatarId: userResult?.avatarId,
                avatarUrl: userResult?.avatarUrl,
                phoneNumber: userResult?.phoneNumber,
                // birthDate: userResult?.birthDate,
                // isActive: userResult?.isActive,

                roleCodes: roleCodesTemp,
                userGroups: groupUserTemp,
                organizationUserProfile: {
                    id: userResult?.organizationUserProfile?.id,
                    gender: userResult?.organizationUserProfile?.gender,
                    userType: userResult?.organizationUserProfile?.userType,
                    lastName: userResult?.organizationUserProfile?.lastName,
                    firstName: userResult?.organizationUserProfile?.firstName,
                    dateOfBirth: userResult?.organizationUserProfile?.dateOfBirth,
                    employmentDate: userResult?.organizationUserProfile?.employmentDate,
                    terminationtDate: userResult?.organizationUserProfile?.terminationtDate,

                    idCardNo: userResult?.organizationUserProfile?.idCardNo,
                    idCardIssuedDate: userResult?.organizationUserProfile?.idCardIssuedDate,
                    idCardIssuedPlace: userResult?.organizationUserProfile?.idCardIssuedPlace,
                    socialInsuranceCode: userResult?.organizationUserProfile?.socialInsuranceCode,

                    // extraInformationObject: userResult?.organizationUserProfile?.extraInformationObject,
                    // organizationUserDocuments: userResult?.organizationUserProfile?.organizationUserDocuments,
                },
            });

            setDataRoleDisabled(newRoleDisabled);

            const newDataWorkingGroups = (groupUserTemp.length > 0)
                ? groupUserTemp
                : [{
                    groupId: "",
                    userTitle: "",
                    id: Date.now().toString(),
                    action: ActionRequest.Create,
                    default: GroupUserDefault.None,
                }];

            setErrorWorkingGroups([]);
            setDataWorkingGroups(newDataWorkingGroups);

            let newGrps = { ...selectedGroups };
            groupUserTemp.forEach(el => {
                newGrps[el.groupId] = parentGroupList.find((p) => p.code === el.groupId);
            });

            setSelectedGroups(newGrps);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
        finally {
            onHideLoading();
        }
    };

    const onValueChange = (value: any, key: string) => {
        setModel({ ...model, [key]: value });
        setModelError((error: any) => (error[key] ? { ...error, [key]: undefined } : error));
    };

    const handleCreateStaff = async ({ newReq, onCallBack }: {
        newReq: IDataModalCreateUpdateStaff;
        onCallBack: () => void;
    }) => {
        try {
            onShowLoading();

            let newData: IDataRequestCreateUpdateUser = {
                clientId: clientId,
                tenantCode: tenantCode,
                serviceCode: serviceCode,
                organizationId: props.organizationId,

                isActive: true,
                password: "123456",
                email: newReq?.email || undefined,
                userName: newReq?.email || undefined,
                phoneNumber: newReq?.phoneNumber || undefined,
                fullName: `${newReq?.lastName || ""} ${newReq?.firstName || ""}`.trim(),

                roleCodes: newReq?.roleCodes,
                userGroups: newReq?.userGroups,

                organizationUserProfile: {
                    lastName: newReq?.lastName,
                    firstName: newReq?.firstName,
                    email: newReq?.email || undefined,
                    phoneNumber: newReq?.phoneNumber || undefined,
                },
            };

            await UserService.create({
                data: newData,
                newDomain: props.newDomain,
            });

            await onCallBack();

            onSuccess(strings.format(strings.Staff.CREATE_SUCCESS, newLableStaff));
        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const handleUpdateStaff = async ({ newReq, onCallBack }: {
        newReq: IDataModalCreateUpdateStaff;
        onCallBack: () => void;
    }) => {
        try {
            onShowLoading();

            const userGroupsTemp: any[] = [];

            for (const item of newReq?.userGroups) {
                const newid = (item.action === ActionRequest.Create) ? undefined : item.id;
                userGroupsTemp.push({
                    id: newid,
                    action: item.action,
                    groupId: item.groupId,
                    manager: item.manager,
                    default: item.default,
                    userTitle: item.userTitle,
                });
            };

            let newData: IDataRequestCreateUpdateUser = {
                clientId: dataDetailUserBackup?.clientId || clientId,
                tenantCode: dataDetailUserBackup?.tenantCode || tenantCode,
                serviceCode: dataDetailUserBackup?.serviceCode || serviceCode,
                organizationId: dataDetailUserBackup?.organizationId || props.organizationId,

                id: dataDetailUserBackup?.id,
                email: dataDetailUserBackup?.email,
                gender: dataDetailUserBackup?.gender,
                userName: dataDetailUserBackup?.userName,
                avatarId: dataDetailUserBackup?.avatarId,
                avatarUrl: dataDetailUserBackup?.avatarUrl,
                birthDate: dataDetailUserBackup?.birthDate,
                phoneNumber: dataDetailUserBackup?.phoneNumber,
                fullName: `${newReq?.lastName || ""} ${newReq?.firstName || ""}`.trim(),

                userGroups: userGroupsTemp,
                roleCodes: newReq?.roleCodes,

                organizationUserProfile: {
                    ...dataDetailUserBackup?.organizationUserProfile,
                    email: newReq?.email,
                    lastName: newReq?.lastName,
                    firstName: newReq?.firstName,
                    phoneNumber: newReq?.phoneNumber,
                },
            };

            await UserService.update({
                data: newData,
                newDomain: props.newDomain,
            });

            await onCallBack();

            onSuccess(strings.format(strings.Staff.UPDATE_SUCCESS, newLableStaff));

        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const checkValidateData = () => {
        let check = true;
        let newError: any = { ...modelError };

        if (Helpers.isNullOrEmpty(model?.firstName)) {
            check = false;
            newError["firstName"] = strings.Common.REQUIRED;
        }

        if (Helpers.isNullOrEmpty(model?.lastName)) {
            check = false;
            newError["lastName"] = strings.Common.REQUIRED;
        }

        if (!Helpers.isNullOrEmpty(model?.phoneNumber)
            && (model?.phoneNumber?.length < 8)) {
            check = false;
            newError["phoneNumber"] = strings.Common.WRONG_PHONE_NUMBER;
        }

        if (Helpers.isNullOrEmpty(model?.email)) {
            check = false;
            newError["email"] = strings.Common.REQUIRED;
        } else {
            if (!Helpers.isValidEmail(model?.email)) {
                check = false;
                newError["email"] = strings.Common.EMAIL_ADDRESS;
            }
        }

        if (
            props.requiredRole &&
            (Helpers.isNullOrEmpty(model.roleCodes) || [...model.roleCodes || []].length === 0)
        ) {
            check = false;
            newError["roleCodes"] = strings.Common.REQUIRED;
        }

        if (!check) {
            setModelError(newError);
        }

        return check;
    };

    const handleAction = () => {
        if (!checkValidateData()) {
            return;
        } else {
            const newUserGroups = [...dataWorkingGroups || []]
                .filter(el => !Helpers.isNullOrEmpty(el.groupId))
                .map((role) => ({
                    userTitle: role.userTitle,
                    groupId: role.groupId,
                    default: role.default,
                    action: role.action,
                }));

            let newRoleCodes: string[] = [...model?.roleCodes || []];

            if (newRoleCodes.length === 0) {
                const itemRoleMember = [...props.dataRoles || []].find(el => (
                    RoleHelpers.isOrganizationMember(el.detail?.roleType)
                ));

                itemRoleMember &&
                    newRoleCodes.push(itemRoleMember?.code as string);
            }

            const newDataReq = {
                id: model?.id,
                email: model?.email,
                lastName: model?.lastName,
                firstName: model?.firstName,
                phoneNumber: model?.phoneNumber,
                userGroups: newUserGroups,
                roleCodes: newRoleCodes,
            };

            if (Helpers.isNullOrEmpty(model.id)) {
                handleCreateStaff({
                    newReq: newDataReq,
                    onCallBack() {
                        props.onCallBack && props.onCallBack();
                        props.setVisibleModal(false);
                        handleClose();
                    },
                });

            } else {
                handleUpdateStaff({
                    newReq: newDataReq,
                    onCallBack() {
                        props.onCallBack && props.onCallBack();
                        props.setVisibleModal(false);
                        handleClose();
                    },
                });
            }
        }
    };

    const handleClose = () => {
        setModelError({});
        setModel({ roleCodes: [], userGroups: [] });

        setSelectedGroups({});
        setErrorWorkingGroups([]);
        setDataWorkingGroups([
            {
                id: "0",
                groupId: "",
                userTitle: "",
                manager: IsTrue.False,
                action: ActionRequest.Create,
                default: GroupUserDefault.Default,
            },
        ]);
    }

    //#region List Working Groups
    const handleChangeValueWorkingGroup = async (id: any, newValue: any, key: keyof IModelWorkingGroup) => {
        const index = [...dataWorkingGroups || []].findIndex(el => el.id === id);

        if (key === "default") {
            setDataWorkingGroups(prev => {
                let newData = [...prev || []];

                if (newData[index].default === GroupUserDefault.Default) return newData;

                newData[index] = {
                    ...newData[index],
                    [key]: newValue ? GroupUserDefault.Default : GroupUserDefault.None,
                };

                return newData.map((item, i) => {
                    if (i === index) {
                        return { ...item, [key]: GroupUserDefault.Default };
                    } else {
                        if (item[key] === GroupUserDefault.Default) {
                            return { ...item, [key]: GroupUserDefault.None };
                        }
                        return item;
                    }
                });
            });
        } else {
            setDataWorkingGroups(prev => {
                let newData = [...prev || []];

                newData[index] = {
                    ...newData[index],
                    [key]: newValue,
                };

                return newData;
            });
        }

        setErrorWorkingGroups((errors) => errors.map((error, errorIndex) => (errorIndex === index ? { ...error, [key]: "" } : error)));
    };

    const handleDeleteItemWorkingGroup = (item: IModelWorkingGroup) => {
        let filteredRoles = [...dataWorkingGroups || []];
        const itemIndex = filteredRoles.findIndex(el => el.id === item.id);
        if (item.action === ActionRequest.Create) {
            filteredRoles = [...dataWorkingGroups || []].filter((role) => role !== item);
        }
        if (item.action === ActionRequest.Update) {
            filteredRoles[itemIndex].action = ActionRequest.Delete;
        }
        if (filteredRoles.filter(el => el.action !== ActionRequest.Delete).length === 0) {
            filteredRoles.push({
                id: Date.now().toString(),
                groupId: "",
                userTitle: "",
                default: GroupUserDefault.None,
                action: ActionRequest.Create,
            })
        }

        setSelectedGroups((grps) => {
            const newGrps = { ...grps };
            delete newGrps[item.groupId];
            return newGrps;
        });

        setDataWorkingGroups(filteredRoles);
        setErrorWorkingGroups((errors) => errors.filter((_, errorIndex) => errorIndex !== itemIndex));

    };

    const RenderListWorkingGroups = () => (
        <Box mt={2}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={1}>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography variant="caption" fontWeight="medium">
                        {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup))}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography variant="caption" fontWeight="medium">
                        {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.STAFF_POSITION, newLableStaff))}
                    </Typography>
                </Grid>
            </Grid>

            {
                newListWorkingGroups.map((itemGroup, index) => {
                    const dataAutocomplete = (props.groupIdDefault === itemGroup.groupId)
                        ? [{ code: props.groupIdDefault, name: itemGroup.groupName?.value?.[language] }]
                        : (
                            !Helpers.isNullOrEmpty(itemGroup.groupId) &&
                                !Helpers.isNullOrEmpty(selectedGroups[itemGroup.groupId])
                                ? [selectedGroups[itemGroup.groupId], ...availableGroups || []]
                                : [...availableGroups || []]
                        );

                    return (
                        <Grid container spacing={1} mt={1} key={index}>
                            <Grid item xs={12} md={1}>
                                <Tooltip title={strings.format(strings.Staff.SELECT_GROUP_DEFAULT, newLableGroup)}>
                                    <Radio
                                        color="info"
                                        checkedIcon={<TaskAlt />}
                                        disabled={props.groupIdDefault === itemGroup.groupId}
                                        checked={itemGroup.default === GroupUserDefault.Default}
                                        onChange={(e) => {
                                            handleChangeValueWorkingGroup(itemGroup.id, e.target.value, "default");
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Autocomplete
                                    required
                                    data={dataAutocomplete}
                                    defaultValue={itemGroup.groupId || ""}
                                    errorMessage={errorWorkingGroups[index]?.groupId}
                                    disabled={props.groupIdDefault === itemGroup.groupId}
                                    placeholder={strings.format(strings.Staff.SELECT_WORK_GROUPS, newLableGroup)}
                                    onChange={(value) => {
                                        setSelectedGroups((grps) => {
                                            const newGrps = { ...grps };
                                            if (!!value) {
                                                newGrps[value] = parentGroupList.find((p) => p.code === value);
                                            }
                                            if (itemGroup.groupId) {
                                                delete newGrps[itemGroup.groupId];
                                            }
                                            return newGrps;
                                        });
                                        handleChangeValueWorkingGroup(itemGroup.id, value, "groupId");
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} md={5}>
                                <Autocomplete
                                    data={props.dataUserTitle}
                                    defaultValue={itemGroup.userTitle || ""}
                                    errorMessage={errorWorkingGroups[index]?.userTitle}
                                    disabled={props.groupIdDefault === itemGroup.groupId}
                                    onChange={(value) => handleChangeValueWorkingGroup(itemGroup.id, value, "userTitle")}
                                    placeholder={Helpers.capitalizeFirstLetter(strings.format(strings.Staff.SELECT_STAFF_POSITION, newLableStaff))}
                                />
                            </Grid>
                            {(props.groupIdDefault !== itemGroup.groupId) &&
                                (
                                    <Grid item xs={12} md={1}>
                                        <IconButton onClick={() => handleDeleteItemWorkingGroup(itemGroup)}>
                                            <Delete color="error" />
                                        </IconButton>
                                    </Grid>
                                )
                            }
                        </Grid>
                    )
                })
            }
        </Box>
    );
    //#endregion List Group Working

    return (
        <Modal
            fullWidth
            maxWidth="md"
            hasActionButton
            visible={props.visibleModal}

            onAction={() => {
                handleAction();
            }}
            onClose={() => {
                props.setVisibleModal(false);

                handleClose();
                Helpers.isFunction(props.onClose) && props.onClose();

            }}
            onClickCloseIcon={() => {
                props.setVisibleModal(false);

                handleClose();
                Helpers.isFunction(props.onClose) && props.onClose();

            }}
            title={
                strings.format(model?.id
                    ? strings.Staff.TITLE_UPDATE_VIEW
                    : strings.Staff.TITLE_CREATE_VIEW,
                    newLableStaff)
            }
        >
            <Grid container spacing={3} p={2}>
                <Grid item xs={12} md={6}>
                    <FormField
                        required
                        maxLength={255}
                        defaultValue={model?.lastName}
                        label={strings.Staff.LAST_NAME}
                        errorMessage={modelError.lastName}
                        placeholder={strings.Staff.ENTER_LAST_NAME}
                        onBlur={(value) => onValueChange(value, "lastName")}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormField
                        required
                        maxLength={255}
                        defaultValue={model?.firstName}
                        label={strings.Staff.FIRST_NAME}
                        errorMessage={modelError.firstName}
                        placeholder={strings.Staff.ENTER_FIRST_NAME}
                        onBlur={(value) => onValueChange(value, "firstName")}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormField
                        required
                        maxLength={255}
                        defaultValue={model?.email}
                        label={strings.Staff.EMAIL}
                        errorMessage={modelError.email}
                        placeholder={strings.Staff.ENTER_EMAIL}
                        onBlur={(value) => onValueChange(value, "email")}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <PhoneNumberInput
                        country={"vn"}
                        errorMessage={modelError?.phoneNumber}
                        defaultValue={model?.phoneNumber || ""}
                        onChangeValue={value => { onValueChange(value, "phoneNumber"); }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Autocomplete
                        multiple
                        isGroupBy
                        required={props.requiredRole}
                        errorMessage={modelError.roleCodes}
                        defaultValue={model?.roleCodes || []}
                        label={strings.format(strings.Staff.STAFF_PERMISSION, newLableStaff)}
                        placeholder={strings.format(strings.Staff.SELECT_STAFF_PERMISSION, newLableStaff)}
                        onChange={(value: any) => {
                            if (Helpers.isNullOrEmpty(value) || [...value || []].length === 0) {
                                onValueChange(dataRoleDisabled, "roleCodes")
                            } else {
                                const newValue = [...value || []];
                                for (const code of dataRoleDisabled) {
                                    ![...value || []].includes(code)
                                        && newValue.push(code);
                                }
                                onValueChange(newValue, "roleCodes");
                            }
                        }}
                        data={[...props.dataRoles || []]}
                        optionDisabled={[
                            ...props.dataRoles.filter(el => (
                                RoleHelpers.isOrganizationOwner(Number(el.detail?.roleType))
                            ))?.map(e => `${e.code}`) || []
                        ]}
                    />
                </Grid>

                <Grid item xs={12} style={{ lineHeight: 1.3 }}>
                    <Box sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}>
                        <Box display="grid">
                            <Typography variant="button" fontWeight="bold">
                                {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup))}
                            </Typography>
                            <Typography variant="caption" color="secondary" >
                                {Helpers.capitalizeFirstLetter(strings.format(strings.Staff.SELECTED_GROUP_WILL_BE_DEFAULT_ONE, newLableGroup, newLableGroup))}
                            </Typography>
                        </Box>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setDataWorkingGroups(prev => {
                                    const newdata = [...prev || []];
                                    newdata.push({
                                        id: Date.now().toString(),
                                        action: ActionRequest.Create,
                                        default: GroupUserDefault.None,
                                        userTitle: "",
                                        groupId: "",
                                    });
                                    return newdata;
                                });
                            }}
                        >
                            <AddOutlined />&nbsp;
                            {strings.Common.ADD_NEW}
                        </Button>
                    </Box>
                    {(newListWorkingGroups.length === 0)
                        ? (
                            <Box mt={2} textAlign={"center"}>
                                <Typography variant="button" color="secondary" fontWeight="regular">
                                    {strings.Common.NO_DATA}
                                </Typography>
                            </Box>
                        )
                        : (<RenderListWorkingGroups />)
                    }
                </Grid>
            </Grid>
        </Modal>
    );
}

export default ModalCreateUpdateMember;
